import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoIcon from '../components/assets/icon.png';
import Footer from '../components/Footer';
import EnquiryModal from '../components/EnquiryModal';
import '../App.css';

const Academy = () => {
  const [selectedCourse, setSelectedCourse] = useState(0);
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleMenuClick = () => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
    document.body.style.overflow = 'unset';
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen(!isDropdownOpen);
  };

  const courses = [
    { 
      title: 'Filmmaking Diploma', 
      desc: '12-month comprehensive program covering all aspects of film production', 
      image: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?q=80&w=800&auto=format&fit=crop', 
      duration: '12 months',
      icon: '🎬',
      highlights: 'Professional Certification'
    },
    { 
      title: 'Acting Workshop', 
      desc: 'Method acting, screen presence, and character development techniques', 
      image: 'https://images.unsplash.com/photo-1503095396549-807759245b35?q=80&w=800&auto=format&fit=crop', 
      duration: '6 months',
      icon: '🎭',
      highlights: 'Screen Presence Training'
    },
    { 
      title: 'Cinematography', 
      desc: 'Camera operation, lighting, composition, and visual storytelling', 
      image: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?q=80&w=800&auto=format&fit=crop', 
      duration: '8 months',
      icon: '📹',
      highlights: 'Advanced Camera Techniques'
    },
    { 
      title: 'Editing & VFX', 
      desc: 'Professional editing software, color grading, and visual effects', 
      image: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?q=80&w=800&auto=format&fit=crop', 
      duration: '6 months',
      icon: '🎞️',
      highlights: 'Industry Software Training'
    },
    { 
      title: 'Screenwriting', 
      desc: 'Story structure, character development, and professional screenplay format', 
      image: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?q=80&w=800&auto=format&fit=crop', 
      duration: '4 months',
      icon: '✍️',
      highlights: 'Creative Writing Focus'
    },
    { 
      title: 'Directing', 
      desc: 'Vision development, actor direction, and on-set management', 
      image: 'https://images.unsplash.com/photo-1478720568477-152d9b164e26?q=80&w=800&auto=format&fit=crop', 
      duration: '10 months',
      icon: '📽️',
      highlights: 'Leadership & Vision'
    }
  ];

  return (
    <div className="service-page">
      {/* Header */}
      <nav className="navbar scrolled">
        <div className="container nav-content">
          <Link to="/" className="logo">
            <img src={logoIcon} alt="Magic Moon Studios" className="logo-icon-img" />
            <span className="logo-text">MAGIC MOON STUDIOS</span>
          </Link>

          <button 
            className="mobile-menu-btn" 
            onClick={(e) => {
              e.stopPropagation();
              setIsMenuOpen(!isMenuOpen);
              setIsDropdownOpen(false);
              document.body.style.overflow = isMenuOpen ? 'unset' : 'hidden';
            }}
          >
            {isMenuOpen ? '✕' : '☰'}
          </button>

          {isMenuOpen && (
            <div 
              className="mobile-menu-backdrop" 
              onClick={(e) => {
                e.stopPropagation();
                setIsMenuOpen(false);
                setIsDropdownOpen(false);
                document.body.style.overflow = 'unset';
              }}
            />
          )}

          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li><Link to="/" onClick={handleMenuClick}>Home</Link></li>
            <li><a href="/#about" onClick={handleMenuClick}>About</a></li>
            <li><a href="/#projects" onClick={handleMenuClick}>Projects</a></li>
            <li className={`dropdown ${isDropdownOpen ? 'active' : ''}`}>
              <a href="#services" onClick={toggleDropdown}>Services ▾</a>
              <ul className="dropdown-menu">
                <li><Link to="/film-production" onClick={handleMenuClick}>Film Production</Link></li>
                <li><Link to="/short-movies" onClick={handleMenuClick}>Short Movies</Link></li>
                <li><Link to="/academy" onClick={handleMenuClick}>Academy</Link></li>
                <li><Link to="/ads-making" onClick={handleMenuClick}>Ads Making</Link></li>
                <li><Link to="/digital-content" onClick={handleMenuClick}>Digital Content</Link></li>
                <li><Link to="/music-production" onClick={handleMenuClick}>Music Production</Link></li>
              </ul>
            </li>
            <li><a href="/#team" onClick={handleMenuClick}>Team</a></li>
            <li><Link to="/#contact" className="contact-btn">Contact</Link></li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="service-hero" style={{ 
        background: 'linear-gradient(rgba(15, 52, 96, 0.85), rgba(26, 26, 46, 0.85)), url("https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=2000&auto=format&fit=crop")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>
        <div className="container">
          <div className="service-hero-content">
            <h1 className="service-hero-title">Film Academy</h1>
            <p className="service-hero-subtitle">
              Professional training in filmmaking, acting, and production techniques
            </p>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section className="service-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-content">
              <h2 style={{ color: '#5B9BD5', marginBottom: '20px' }}>Learn From Industry Experts</h2>
              <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                Magic Moon Studios Academy offers comprehensive training programs designed by industry professionals. 
                Whether you're a beginner or looking to advance your skills, our courses cover everything from basic 
                camera operation to advanced cinematography and directing techniques.
              </p>
              <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                Our hands-on approach ensures you gain practical experience on real film sets, learn from working 
                professionals, and build a portfolio that showcases your talent to potential employers.
              </p>
            </div>
            <div className="overview-image">
              <img 
                src="https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?q=80&w=800&auto=format&fit=crop" 
                alt="Film Academy Training"
                style={{ 
                  width: '100%', 
                  height: '400px', 
                  objectFit: 'cover',
                  borderRadius: '15px',
                  border: '3px solid #B8860B',
                  boxShadow: '0 10px 30px rgba(184, 134, 11, 0.3)'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Courses Offered */}
      <section className="service-offerings" style={{ background: 'linear-gradient(to bottom, #F0F9FF 0%, #E3F2FD 100%)', padding: '80px 0' }}>
        <div className="container">
          <h2 style={{ 
            textAlign: 'center', 
            color: '#5B9BD5', 
            marginBottom: '60px', 
            fontSize: '4rem',
            fontFamily: "'Dancing Script', cursive",
            fontWeight: 'bold',
            textShadow: '2px 2px 4px rgba(91, 155, 213, 0.3)',
            letterSpacing: '2px'
          }}>Our Courses</h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center', maxWidth: '1400px', margin: '0 auto' }}>
            {/* Circular Course Navigation */}
            <div style={{ position: 'relative', width: '100%', height: '700px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {/* Center Circle */}
              <div style={{
                position: 'absolute',
                width: '220px',
                height: '220px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #87CEEB 0%, #5B9BD5 100%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontWeight: '700',
                fontSize: '1.5rem',
                textAlign: 'center',
                boxShadow: '0 15px 50px rgba(91, 155, 213, 0.4)',
                border: '6px solid #B8860B',
                zIndex: 10
              }}>
                <div style={{ fontSize: '1.8rem' }}>ALL</div>
                <div style={{ fontSize: '1.8rem' }}>COURSES</div>
              </div>

              {/* Course Circles */}
              {courses.map((course, index) => {
                const angle = (index * 60) - 90; // 360/6 = 60 degrees spacing, -90 to start from top
                const radius = 260;
                const x = Math.cos(angle * Math.PI / 180) * radius;
                const y = Math.sin(angle * Math.PI / 180) * radius;
                
                return (
                  <div
                    key={index}
                    onClick={() => setSelectedCourse(index)}
                    style={{
                      position: 'absolute',
                      width: selectedCourse === index ? '160px' : '140px',
                      height: selectedCourse === index ? '160px' : '140px',
                      borderRadius: '50%',
                      background: selectedCourse === index 
                        ? 'linear-gradient(135deg, #D4AF37 0%, #FFD700 100%)'
                        : 'linear-gradient(135deg, #87CEEB 0%, #5B9BD5 100%)',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: selectedCourse === index ? '#1a1a2e' : '#fff',
                      cursor: 'pointer',
                      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                      transform: `translate(${x}px, ${y}px)`,
                      boxShadow: selectedCourse === index 
                        ? '0 20px 60px rgba(212, 175, 55, 0.6), 0 0 0 4px #B8860B'
                        : '0 10px 30px rgba(91, 155, 213, 0.3)',
                      zIndex: selectedCourse === index ? 5 : 1
                    }}
                  >
                    <div style={{ fontSize: '3rem', marginBottom: '8px' }}>{course.icon}</div>
                    <div style={{ 
                      fontSize: '0.85rem', 
                      fontWeight: '700', 
                      textAlign: 'center',
                      lineHeight: '1.2',
                      maxWidth: '90%'
                    }}>{course.title.split(' ').length > 1 ? course.title.split(' ')[0] : course.title}</div>
                  </div>
                );
              })}
            </div>

            {/* Course Detail Card */}
            <div style={{
              background: '#fff',
              borderRadius: '30px',
              overflow: 'hidden',
              boxShadow: '0 25px 70px rgba(91, 155, 213, 0.3)',
              border: '4px solid #B8860B',
              minHeight: '550px',
              transition: 'all 0.4s ease'
            }}>
              <div style={{
                width: '100%',
                height: '320px',
                overflow: 'hidden',
                position: 'relative'
              }}>
                <img 
                  src={courses[selectedCourse].image}
                  alt={courses[selectedCourse].title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.4s ease'
                  }}
                />
                <div style={{
                  position: 'absolute',
                  top: '25px',
                  left: '25px',
                  background: 'linear-gradient(135deg, #D4AF37 0%, #FFD700 100%)',
                  padding: '15px',
                  borderRadius: '20px',
                  fontSize: '3rem',
                  boxShadow: '0 8px 25px rgba(0, 0, 0, 0.4)',
                  border: '3px solid #B8860B'
                }}>
                  {courses[selectedCourse].icon}
                </div>
              </div>
              <div style={{ padding: '45px' }}>
                <h3 style={{
                  fontSize: '2.2rem',
                  color: '#2C5282',
                  marginBottom: '18px',
                  fontWeight: '700'
                }}>{courses[selectedCourse].title}</h3>
                <p style={{
                  fontSize: '1.15rem',
                  color: '#666',
                  lineHeight: '1.9',
                  marginBottom: '30px'
                }}>{courses[selectedCourse].desc}</p>
                <div style={{
                  display: 'flex',
                  gap: '15px',
                  marginBottom: '35px',
                  flexWrap: 'wrap'
                }}>
                  <div style={{
                    background: 'linear-gradient(135deg, rgba(91, 155, 213, 0.2) 0%, rgba(135, 206, 235, 0.15) 100%)',
                    padding: '12px 24px',
                    borderRadius: '25px',
                    border: '2px solid #5B9BD5',
                    color: '#5B9BD5',
                    fontWeight: '700',
                    fontSize: '1rem'
                  }}>
                    Duration: {courses[selectedCourse].duration}
                  </div>
                  <div style={{
                    background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.2) 0%, rgba(255, 215, 0, 0.15) 100%)',
                    padding: '12px 24px',
                    borderRadius: '25px',
                    border: '2px solid #D4AF37',
                    color: '#B8860B',
                    fontWeight: '700',
                    fontSize: '1rem'
                  }}>
                    {courses[selectedCourse].highlights}
                  </div>
                </div>
                <button style={{
                  width: '100%',
                  padding: '20px',
                  background: 'linear-gradient(135deg, #5B9BD5 0%, #87CEEB 100%)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '35px',
                  fontSize: '1.15rem',
                  fontWeight: '700',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '12px',
                  boxShadow: '0 8px 20px rgba(91, 155, 213, 0.3)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'linear-gradient(135deg, #D4AF37 0%, #FFD700 100%)';
                  e.currentTarget.style.color = '#1a1a2e';
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = '0 12px 35px rgba(255, 215, 0, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'linear-gradient(135deg, #5B9BD5 0%, #87CEEB 100%)';
                  e.currentTarget.style.color = '#fff';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(91, 155, 213, 0.3)';
                }}>
                  Learn More <span style={{ fontSize: '1.4rem' }}>→</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section style={{ padding: '80px 0' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', color: '#5B9BD5', marginBottom: '50px', fontSize: '2.5rem' }}>Why Choose Our Academy</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
            {[
              { title: 'Industry Professionals', desc: 'Learn from filmmakers who have worked on major productions' },
              { title: 'Hands-On Training', desc: 'Real film sets, professional equipment, and practical projects' },
              { title: 'Career Support', desc: 'Portfolio building, networking events, and job placement assistance' },
              { title: 'Flexible Schedule', desc: 'Weekend batches, evening classes, and online options available' }
            ].map((benefit, index) => (
              <div key={index} style={{
                padding: '30px',
                background: 'linear-gradient(135deg, rgba(91, 155, 213, 0.1) 0%, rgba(135, 206, 235, 0.05) 100%)',
                borderRadius: '15px',
                border: '2px solid #B8860B'
              }}>
                <h3 style={{ color: '#FFD700', marginBottom: '15px', fontSize: '1.3rem' }}>✓ {benefit.title}</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>{benefit.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta" style={{ 
        background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)', 
        padding: '80px 0',
        textAlign: 'center',
        color: '#fff'
      }}>
        <div className="container">
          <h2 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#FFD700' }}>Start Your Filmmaking Journey</h2>
          <p style={{ fontSize: '1.2rem', marginBottom: '30px', color: '#87CEEB' }}>
            Enroll in our courses and learn from the best in the industry
          </p>
          <button onClick={() => setIsEnquiryOpen(true)} style={{
            display: 'inline-block',
            padding: '15px 40px',
            background: 'linear-gradient(135deg, #B8860B 0%, #FFD700 100%)',
            color: '#1a1a2e',
            borderRadius: '30px',
            fontWeight: '700',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1rem'
          }}>
            Apply Now
          </button>
        </div>
      </section>

      {/* Enquiry Modal */}
      <EnquiryModal 
        isOpen={isEnquiryOpen} 
        onClose={() => setIsEnquiryOpen(false)} 
        serviceName="Film Academy"
      />

      {/* Footer Component */}
      <Footer />
    </div>
  );
};

export default Academy;
